import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';
import { GridHeaderMenuTemplateDirective } from './header-menu.template.directive';

@Directive({ selector: 'grid-header-menu' })
export class GridHeaderMenuDirective {
  // @Input()
  @ContentChild(GridHeaderMenuTemplateDirective, { read: TemplateRef })
  template: TemplateRef<any>;
}
